const REACT_APP_IMAGE_S3_BUCKET_NAME = process.env.REACT_APP_IMAGE_S3_BUCKET_NAME || 'luna-local-images';

module.exports = {
  REACT_APP_IMAGE_S3_BUCKET_NAME,
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000/v1',
  REACT_APP_IMAGE_S3_BUCKET_URL: `https://${REACT_APP_IMAGE_S3_BUCKET_NAME}.s3.amazonaws.com/`,
  PORT: process.env.PORT || '8001'
};
